import React, { useContext, useEffect, useState } from "react";
import BannerIMG from "../images/newimg/img1.png";
import BannerMobileIMG from "../images/aboutmobile.png";
import { ReactComponent as CheckSvg } from "../images/newimg/check.svg";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import AOS from "aos";
import GradientIMG from "../images/newimg/gradient5.png";
import { ListGroup, Button } from "react-bootstrap";
import ReqIMG from "../images/newimg/req.jpg";
import GlowImg from "../images/newimg/glow.png";
import Gradient2IMG from "../images/newimg/gradenthow.jpg";
import Gradient3IMG from "../images/newimg/gardient6.jpg";
import FeatureIMG1 from "../images/feature.png";
import FeatureIMG2 from "../images/controll_schedule.png";
import FeatureIMG3 from "../images/get_paid_promptly.png";
import FeatureIMG4 from "../images/online_appointments.png";

import { Link } from "react-router-dom";
import { trackScreenView, trackButtonClick, getUserTrackingParams } from "../../utility/services/analyticsService";

const Therapist = () => {
  const { setAuthRole, user } = useContext(AuthContext);
  const userDetails = user.details ? user.details : null;
  const isUserDetails = userDetails != null;
  const userRole = isUserDetails ? userDetails.role : null;
  const { enctyptDataFun } = Functions();
  const set_login_role = () => {
    setAuthRole("Therapist");
    localStorage.setItem("E_C_R_O_L_E", enctyptDataFun("Therapist"));
  };
  useEffect(() => {
    trackScreenView("therapist_landing_screen", { screen_name: "Therapist Landing", ...getUserTrackingParams(user) });
    AOS.init({
      disable: true,
      once: true,
    });
    return () => AOS.refresh();
  }, []);

  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      label: "Manage your<br class='hideBr' /> clients",
      content: "Manage your clients content",
    },
    {
      label: "Control your<br class='hideBr' /> schedule",
      content: "Control your schedule content",
    },
    { label: "Get paid promptly", content: "Get paid promptly content" },
    {
      label: "Online<br class='hideBr' /> appointments",
      content: "Online appointments content",
    },
  ];

  return (
    <>
      <section className="therapis_box ptbody therapis_boxNew">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-md-6 order-1 order-sm-0 order-md-0 order-lg-0"
              // data-aos="fade-right"
              // data-aos-duration="2000"
              // data-aos-delay="100"
            >
              <img
                src={BannerIMG}
                alt=""
                className="img-fluid aboutImgNew d-none d-sm-block"
              />
              <img
                src={BannerMobileIMG}
                alt=""
                className="img-fluid aboutImgNew d-block d-sm-none"
              />
            </div>
            <div
              className="col-md-6 mb-3 mb-sm-0 mb-lg-0 mb-mb-0"
              // data-aos="fade-left"
              // data-aos-duration="2000"
              // data-aos-delay="100"
            >
              <div className="contentBox">
                <h3>for therapists</h3>
                <h1 className="mb-4">
                  <span>Work from anywhere, help people everywhere</span>
                </h1>
                <p>
                  At eCare Therapy, we provide a flexible and supportive
                  platform for therapists to manage their practice and connect
                  with clients seamlessly. We give you control over your rates,
                  scheduling, and work environment, so you can focus on what you
                  do best—helping people.
                </p>
                <div className="for_therapist_get_start_btn">
                  <Button
                    data-aos="fade-up"
                    data-aos-duration="2000"
                    data-aos-delay="50"
                    className="btn btn-primary btn-white w-40 hover_orange"
                    onClick={() => {
                      trackButtonClick("get_started_cta", { button_name: "Get Started", screen_name: "Therapist Landing", button_position: "hero_section" });
                      if (isUserDetails) return;
                      set_login_role();
                    }}
                    to={isUserDetails ? "/dashboard" : `/login`}
                    as={Link}
                  >
                    Get Started
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 care_container"
        style={{ backgroundImage: `url(${GradientIMG})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <h2 className="text-center">
                <span>Why eCare Therapy?</span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="care_box">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th
                          style={{
                            minWidth: "200px",
                          }}
                          className="text-primary therapist_table_header"
                        >
                          eCare Therapy
                        </th>
                        <th
                          style={{
                            minWidth: "200px",
                          }}
                          className="other_platform therapist_table_header"
                        >
                          Other platforms
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Set your own rates</td>
                        <td>
                          You control your pricing, starting at $39 for a
                          30-minute session
                        </td>
                        <td>Fixed rates or limits on what you can charge</td>
                      </tr>
                      <tr>
                        <td>Payment model</td>
                        <td>Payment deposits within 24-72 hours of session</td>
                        <td>
                          Paid on set schedules - weekly, biweekly. Delayed
                          payments or complicated payout processes
                        </td>
                      </tr>
                      <tr>
                        <td>Cost to join</td>
                        <td>Free to join with no upfront costs</td>
                        <td>Monthly fees or upfront costs</td>
                      </tr>
                      <tr>
                        <td>Customizable profile</td>
                        <td>
                          Tailor your profile to showcase your expertise,
                          specialties, and languages to attract clients that
                          align with your professional focus
                        </td>
                        <td>Limited customization for your profile</td>
                      </tr>
                      <tr>
                        <td>Session formats</td>
                        <td>Offer video, audio, or chat sessions</td>
                        <td>
                          Varied - some limited to one format for all clients
                        </td>
                      </tr>
                      <tr>
                        <td>Insurance required</td>
                        <td>
                          We do not accept insurance. No paperwork or waiting
                          for reimbursements
                        </td>
                        <td>
                          Often requires insurance, involving paperwork, delays,
                          and more restrictions on fees/accepting clients
                        </td>
                      </tr>
                      <tr>
                        <td>Experience requirements</td>
                        <td>
                          Open to practicing, certified therapists at various
                          career stages
                        </td>
                        <td>
                          Typically require certain years of experience or other
                          limitations
                        </td>
                      </tr>
                      <tr>
                        <td>Platform fees</td>
                        <td>Receive 80% of your session fee</td>
                        <td>
                          Online therapy platforms can take 50%-60% of the
                          client's payment per session from therapists
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 therapis_box">
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="contentBox">
                <h1 className="mb-3">
                  <span>Requirements</span>
                </h1>
                <p>To join eCare Therapy as a therapist, you’ll need:</p>
                <ListGroup>
                  <ListGroup.Item>
                    <CheckSvg /> A valid clinical therapy license (e.g., LCSW,
                    LMFT, LPC, PsyD, or equivalent)
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <CheckSvg /> A National Provider Identifier (NPI) number
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <CheckSvg /> Access to a smartphone, laptop, or desktop with
                    a webcam and reliable internet connection
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <CheckSvg /> Residency in the United States
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </div>
            <div
              className="col-md-6"
              // data-aos="fade-right"
              // data-aos-duration="2000"
              // data-aos-delay="100"
            >
              <div className="reqPos">
                <img src={ReqIMG} alt="" className="img-fluid" />
                <img src={GlowImg} alt="" className="img-fluid glowStyle" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 getStarted"
        style={{ backgroundImage: `url(${Gradient2IMG})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-0 mb-md-4">
              <h2 className="text-center textLeftMObile">
                <span className="text-white">
                  Getting started in 4 simple steps
                </span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-6 col-lg-3">
              <h5>01</h5>
              <h4>Create your profile</h4>
              <p>
                Download the eCare Therapy app or visit our website and fill out
                your professional details.
              </p>
            </div>
            <div className="col-sm-6 col-6 col-lg-3">
              <h5>02</h5>
              <h4>Submit your credentials</h4>
              <p>Upload your license and certification to get verified.</p>
            </div>
            <div className="col-sm-6 col-6 col-lg-3">
              <h5>03</h5>
              <h4>Start accepting clients</h4>
              <p>
                Once approved, you can begin scheduling and conducting sessions
                immediately.
              </p>
            </div>
            <div className="col-sm-6 col-6 col-lg-3">
              <h5>04</h5>
              <h4>Enjoy the freedom</h4>
              <p>
                Work from home, set your hours, and enjoy immediate payments for
                your hard work.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 features_container"
        style={{ backgroundImage: `url(${Gradient3IMG})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <h3 className="text-center">KEY FEATURES</h3>
              <h2 className="text-center">
                <span>Empowering therapists to thrive</span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="tabs-container">
                <div className="tabs-scroll">
                  <div className="divider_box" />
                  {tabs.map((tab, index) => (
                    <div
                      key={index}
                      className={`tab-item ${
                        activeTab === index ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(index)}
                      dangerouslySetInnerHTML={{ __html: tab.label }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
            {activeTab == 0 && (
              <div className="col-md-12 text-center">
                <p className="mb-5">
                  Keep track of all your appointments and client details in one
                  place.
                </p>
                <div className="feature_img">
                  <img src={FeatureIMG1} alt="" className="img-fluid" />
                </div>
              </div>
            )}
            {activeTab == 1 && (
              <div className="col-md-12 text-center">
                <p className="mb-5">
                  Easily set your availability to match your lifestyle.
                </p>
                <div className="feature_img">
                  <img src={FeatureIMG2} alt="" className="img-fluid" />
                </div>
              </div>
            )}
            {activeTab == 2 && (
              <div className="col-md-12 text-center">
                <p className="mb-5">
                  No delays, no hassle. You get paid after every session
                </p>
                <div className="feature_img">
                  <img src={FeatureIMG3} alt="" className="img-fluid" />
                </div>
              </div>
            )}
            {activeTab == 3 && (
              <div className="col-md-12 text-center">
                <p className="mb-5">
                  Conduct sessions via secure video, audio, or chat, ensuring{" "}
                  <br className="hideBr" />
                  comfort and flexibility for you and your clients.
                </p>
                <div className="feature_img">
                  <img src={FeatureIMG4} alt="" className="img-fluid" />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="for_therapist_get_start_btn2">
          <Button
            data-aos="fade-up"
            data-aos-duration="2000"
            data-aos-delay="50"
            className="btn btn-primary btn-white w-40 hover_orange"
            onClick={() => {
              trackButtonClick("get_started_cta", { button_name: "Get Started", screen_name: "Therapist Landing", button_position: "features_section" });
              if (isUserDetails) return;
              set_login_role();
            }}
            to={isUserDetails ? "/dashboard" : `/login`}
            as={Link}
          >
            Get Started
          </Button>
        </div>
      </section>
    </>
  );
};

export default Therapist;
